import { mq } from '@stylesheets/tools';
import styled, { css } from 'styled-components';

const StyledLanguageSwitch = styled.div`
  display: inline-block;
  position: relative;
  text-transform: uppercase;

  a {
    font-size: 18px;
    font-weight: 400;
    line-height: 1;

    ${mq('m')} {
      font-size: 28px;
    }
  }

  ${props =>
    props.inverted &&
    css`
      a {
        color: #fff;
      }
    `}

  @media print {
    display: none;
  }
`;

export default StyledLanguageSwitch;
